<template>
  <el-table-column
    prop="delivery_date"
    sortable="custom"
    label="Szállítás dátuma"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      {{ scope.row.delivery_date | date }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'delivery_date',
  };
</script>
